import React, { useEffect, useState } from "react";
import LineChart from "./LineChart";
import EmployeeTable from "./EmployeeTable";
import { getDashboardData, getDashboardEmployye } from "../../../api/api";
import "react-loading-skeleton/dist/skeleton.css"; //
import Skeleton from "react-loading-skeleton";
import { useAuth } from "../../../context/AuthProvider";
const Dashboard = () => {
  const [dashboard, setDashboard] = useState({});
  const [loading, setLoading] = useState(true);
  const [empDash, setEmpData] = useState(null)
  const { user } = useAuth();
  useEffect(() => {
    if (user) {
      if (user.role === "super-admin") {
        getDashboardData().then((res) => {
          setDashboard(res.data);
          setLoading(false);
        });
      } else {
        getDashboardEmployye(user._id).then((res) => {
          setEmpData(res.data);
          setLoading(false);
        });
      }
    }
  }, []);
  // console.log('EMP',empDash)
  const stats = [
    {
      title: "No. of Customers",
      value: `${dashboard.customerCount}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
        </svg>
      ),
      bgColor: "bg-orange-100",
      textColor: "text-orange-500",
    },
    {
      title: "No. of Vendors",
      value: `${dashboard.vendorCount}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
            clipRule="evenodd"
          />
        </svg>
      ),
      bgColor: "bg-green-100",
      textColor: "text-green-500",
    },
    {
      title: "Total Projects",
      value: `${dashboard.projectCount}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
        </svg>
      ),
      bgColor: "bg-blue-100",
      textColor: "text-blue-500",
    },
    {
      title: "Total Employees",
      value: `${dashboard.employeeCount}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
            clipRule="evenodd"
          />
        </svg>
      ),
      bgColor: "bg-teal-100",
      textColor: "text-teal-500",
    },
  ];

  const projects = [
    {
      title: "Total Projects",
      value: user?.role === "super-admin" ? `${dashboard.projectCount}` : `${empDash?.projectsCount}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
        </svg>
      ),
      bgColor: "bg-blue-100",
      textColor: "text-blue-500",
    },
    {
      title: "Completed Projects",
      value: user?.role === "super-admin" ? `${dashboard.completedProjects}` : `${empDash?.completed}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
        </svg>
      ),
      bgColor: "bg-green-100",
      textColor: "text-green-500",
    },
    {
      title: "Ongoing Projects",
      value: user?.role === "super-admin" ? `${dashboard.inProgressProjects}` : `${empDash?.inprogress}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
        </svg>
      ),
      bgColor: "bg-orange-100",
      textColor: "text-orange-500",
    },
    {
      title: "upcoming Projects",
      value: user?.role === "super-admin" ? `${dashboard.upcomingProjects}` : `${empDash?.notStarted}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
        </svg>
      ),
      bgColor: "bg-red-100",
      textColor: "text-red-500",
    },
  ];

  const payments = [
    {
      title: "Total Payment",
      value: `${dashboard.totalPayments}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" />
        </svg>
      ),
      bgColor: "bg-blue-100",
      textColor: "text-blue-500",
    },
    {
      title: "Not yet Payment",
      value: `${dashboard.pendingPayments}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
            clipRule="evenodd"
          />
        </svg>
      ),
      bgColor: "bg-orange-100",
      textColor: "text-orange-500",
    },
    {
      title: "Received Payment",
      value: `${dashboard.completedPayments}`,
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" />
        </svg>
      ),
      bgColor: "bg-red-100",
      textColor: "text-red-500",
    },
  ];
  const loadingSkeleton = (
    <div className="flex space-x-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          className={`flex items-center p-4 rounded ${stat.bgColor}`}
        >
          <Skeleton circle={true} height={40} width={40} />
          <div className="ml-2">
            <Skeleton width={100} />
            <Skeleton width={50} />
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className=" p-5">
      {user?.role === "super-admin" ? (
        <div className="p-6  poppins-bold">
          <h2 class="my-6 text-2xl font-semibold text-gray-700 dark1:text-gray-200">
            Dashboard
          </h2>
          {loading ? (
            loadingSkeleton // Show skeleton while loading
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className={`p-4 ${stat.bgColor} rounded-lg shadow-md flex justify-between items-center`}
                >
                  <div>
                    <h3 className="text-sm font-medium">{stat.title}</h3>
                    <p className={`text-xl font-semibold ${stat.textColor}`}>
                      {stat.value}
                    </p>
                  </div>
                  <div
                    className={`p-3 rounded-full ${stat.textColor} bg-white`}
                  >
                    {stat.icon}
                  </div>
                </div>
              ))}
            </div>
          )}
          <h2 class="my-6 text-2xl font-semibold text-gray-700 dark1:text-gray-200">
            Payments
          </h2>
          {loading ? (
            loadingSkeleton // Show skeleton while loading
          ) : (
            <div className="grid gap-6 mb-8 md:grid-cols-2 xl:grid-cols-3 mt-5">
              {payments.map((payments, index) => (
                <div
                  key={index}
                  className={`p-4 ${payments.bgColor} rounded-lg shadow-md flex justify-between items-center`}
                >
                  <div>
                    <h3 className="text-sm font-medium">{payments.title}</h3>
                    <p
                      className={`text-xl font-semibold ${payments.textColor}`}
                    >
                      {payments.value}
                    </p>
                  </div>
                  <div
                    className={`p-3 rounded-full ${payments.textColor} bg-white`}
                  >
                    {payments.icon}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Projects Section */}
          <h2 class="my-6 text-2xl font-semibold text-gray-700 dark1:text-gray-200">
            Projects
          </h2>
          {loading ? (
            loadingSkeleton // Show skeleton while loading
          ) : (
            <div className="grid  mb-8 md:grid-cols-2 xl:grid-cols-4 gap-4">
              {projects.map((project, index) => (
                <div
                  key={index}
                  className={`p-4 ${project.bgColor} rounded-lg shadow-md flex justify-between items-center`}
                >
                  <div>
                    <h3 className="text-sm font-medium">{project.title}</h3>
                    <p className={`text-xl font-semibold ${project.textColor}`}>
                      {project.value}
                    </p>
                  </div>
                  <div
                    className={`p-3 rounded-full ${project.textColor} bg-white`}
                  >
                    {project.icon}
                  </div>
                </div>
              ))}
            </div>
          )}
          {/* <div className="">
            <h2 className="my-6 text-2xl font-semibold text-gray-700">Chart</h2>
            <LineChart />
          </div>
          <EmployeeTable /> */}
        </div>
      ) : (
        <div>
          <h2 class="my-6 text-2xl font-semibold text-gray-700 dark1:text-gray-200">
            Projects
          </h2>
          {loading ? (
            loadingSkeleton // Show skeleton while loading
          ) : (
            <div className="grid  mb-8 md:grid-cols-2 xl:grid-cols-4 gap-4">
              {projects.map((project, index) => (
                <div
                  key={index}
                  className={`p-4 ${project.bgColor} rounded-lg shadow-md flex justify-between items-center`}
                >
                  <div>
                    <h3 className="text-sm font-medium">{project.title}</h3>
                    <p className={`text-xl font-semibold ${project.textColor}`}>
                      {project.value}
                    </p>
                  </div>
                  <div
                    className={`p-3 rounded-full ${project.textColor} bg-white`}
                  >
                    {project.icon}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Dashboard;
